import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * NOTE: this is a temporary solution for class components to inject some react-router features.
 */
export const withReactRouter =
  <P,>(Component: React.FC<P>) =>
  // eslint-disable-next-line react/function-component-definition
  (props: P) => {
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} navigate={navigate} urlParams={params} />;
  };
